import React from "react";
import styles from "./FooterList.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

export const FooterList = ({ links, header }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLinkClick = (e, linkPath) => {
    if (location.pathname === linkPath) {
      e.preventDefault(); // prevent default <Link> behavior
      // go to a temp route and back to force remount
      navigate("/refresh", { replace: true });
      setTimeout(() => {
        navigate(linkPath, { replace: true });
      }, 0);
    }
  };

  return (
    <div className={styles.footerContainer}>
      <div className={styles.content}>
        <h5 className={styles.h4}>{header}</h5>
        <ul className={styles.ul}>
          {links.map((link, index) => (
            <li key={index}>
              <Link to={link.src} onClick={(e) => handleLinkClick(e, link.src)}>
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

FooterList.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  header: PropTypes.string.isRequired,
};
